import { AutocompleteRenderGetTagProps, Chip } from '@mui/material';
import AppSelect from 'components/AppSelect';
import { Role } from 'types';

interface RoleSelectProps {
  value: Role[] | null;
  onChange: (roles: Role[]) => void;
  options: Role[];
  error?: boolean;
  helperText?: string;
}

const RoleSelect = ({ value, onChange, options, error, helperText }: RoleSelectProps) => {
  const getSelectedRoles = (): Role[] => (!value || !Array.isArray(value) ? [] : value);

  const handleChange = (event: React.SyntheticEvent, newValue: Role[]) => {
    onChange(newValue || []);
  };

  const renderTags = (value: Role[], getTagProps: AutocompleteRenderGetTagProps) => {
    return value.map((role, index) => (
      <Chip {...getTagProps({ index })} key={role.id} label={role.title} size="small" />
    ));
  };

  return (
    <AppSelect<Role, true>
      multiple
      options={options}
      getOptionLabel={(option) => option.title}
      value={getSelectedRoles()}
      onChange={handleChange}
      renderTags={renderTags}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      label="Роли"
      textFieldProps={{ error, helperText }}
    />
  );
};

export default RoleSelect;
